import moment from 'moment';

export const formatDate = (
  value: moment.MomentInput,
  options?: { format?: string; empty?: string }
) => {
  return value
    ? moment(value).format(options?.format || 'HH:mm - DD/MM/YYYY')
    : options?.empty || '';
};
